import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { ReactNode } from "react";

export const ElementProviderStripe = ({
    children,
}: {
    children: ReactNode;
}) => {
    const stripePublickey = process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY;
    return stripePublickey ? (
        <Elements
            options={{ locale: "en-GB" }}
            stripe={loadStripe(stripePublickey)}
        >
            {children}
        </Elements>
    ) : null;
};
